import React, { Component } from 'react';
import SSRAwareQuery from '../SSRAwareQuery';
import Head from 'next/head';
import gql from 'graphql-tag';

export const query = gql`
  query configs {
    application(name: HOTELONLYBOOKING) {
      ... on HotelOnlyBooking {
        configurations {
          googleTagManagerId
        }
      }
    }
  }
`;

class TagManager extends Component {
  generateDataLayerScript() {
    const dataLayer = 'window.dataLayer = window.dataLayer || [];';

    return (
      <script
        key="dataLayer"
        dangerouslySetInnerHTML={{
          __html: dataLayer,
        }}
      />
    );
  }

  generateGTMScript(id) {
    const GTMScript = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${id}');`;

    return (
      <script
        key="gtm"
        dangerouslySetInnerHTML={{
          __html: GTMScript,
        }}
      />
    );
  }

  generateGTMNoScript(id) {
    // Set this content as a string. See: https://github.com/facebook/react/issues/11423
    const GTMNoScript = `<iframe title="Google Tag Manager" src="//www.googletagmanager.com/ns.html?id=${id}" height="0" width="0" style="display:none;visibility:hidden;"/>`;

    return (
      <noscript
        dangerouslySetInnerHTML={{
          __html: GTMNoScript,
        }}
      />
    );
  }

  render() {
    return (
      <SSRAwareQuery query={query}>
        {({ loading, error, data }) => {
          if (loading) {
            return null;
          }
          if (error) {
            throw error;
          }
          return (
            <React.Fragment>
              <Head>
                {this.generateDataLayerScript()}
                {this.generateGTMScript(
                  data.application.configurations.googleTagManagerId
                )}
              </Head>
              {this.generateGTMNoScript(
                data.application.configurations.googleTagManagerId
              )}
            </React.Fragment>
          );
        }}
      </SSRAwareQuery>
    );
  }
}

export default TagManager;
